import KitFadeView from '@omni/kit/components/KitFadeView';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import React, { ReactElement } from 'react';
import { ViewStyle } from 'react-native';

import PlayerButton, { PlayerButtonSizes } from '../PlayerButton';

export default function SkipBackwardControl({
  isVisible = true,
  style,
  onPressOut,
  onPress,
  size,
}: {
  isVisible?: boolean;
  style?: ViewStyle;
  onPressOut?: () => void;
  onPress?: () => void;
  size?: PlayerButtonSizes;
}): ReactElement {
  const { t } = useTranslation('media');

  return (
    <KitFadeView show={isVisible} style={style}>
      <PlayerButton
        icon='skip-backward-10'
        onPressOut={onPressOut}
        onPress={onPress}
        size={size}
        frameless
        tooltipProps={{
          label: `${t('skipBackward')} (j)`,
        }}
      />
    </KitFadeView>
  );
}
